import React, { useState, useEffect } from "react";
import heroImage from "../assets/homepage.webp";

const HeroBanner = () => {
  const [latestCategory, setLatestCategory] = useState({
    id: "vR9jS5asKBUL3CgqMBHA", // Default ID for fallback link
    name: "Executive Men Shoes", // Default name
    link: "/shop/category/vR9jS5asKBUL3CgqMBHA", // Default link
  });

  const [loadingCategory, setLoadingCategory] = useState(true);
  const [animateText, setAnimateText] = useState(false);

  // Fetch latest category on mount
  useEffect(() => {
    const loadLatestCategory = async () => {
      setLoadingCategory(true);
      // You could fetch here if needed — fallback below:
      setLatestCategory({
        id: "vR9jS5asKBUL3CgqMBHA",
        name: "Executive Men Shoes",
        link: "/shop/category/vR9jS5asKBUL3CgqMBHA",
      });
      setLoadingCategory(false);
    };

    loadLatestCategory();
  }, []);

  // Animate text after mount
  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimateText(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  const { name: categoryName, link: categoryLink } = latestCategory;

  return (
    <section className="relative bg-gradient-to-br from-darktaupe to-charcoal overflow-hidden">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16 px-2 lg:px-3 py-20">

        {/* LEFT CONTENT - reduced width */}
        <div className="flex-[0.8] lg:flex-[0.6] text-center lg:text-left">
          <p className="uppercase tracking-[0.25em] text-beige text-sm font-semibold mb-4">
            To Inspire
          </p>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-agatha leading-tight text-offwhite mb-6">
            <span
              className={`inline-block transition-all duration-1000 ease-out ${
                animateText ? "translate-x-0 opacity-100" : "-translate-x-8 opacity-0"
              }`}
            >
              A Refined
            </span>
            <br />
            <span
              className={`inline-block transition-all duration-1000 ease-out delay-300 ${
                animateText ? "translate-x-0 opacity-100" : "-translate-x-8 opacity-0"
              }`}
            >
              Lifestyle
            </span>
          </h1>

          <p className="text-lg text-beige/80 max-w-sm mx-auto lg:mx-0 mb-8">
            Discover premium leather goods crafted with timeless design, tailored for modern living.
          </p>

          <a
            href="/shop"
            className="inline-block px-8 py-3 bg-tan text-charcoal rounded-full shadow-md 
                       hover:bg-beige hover:text-darktaupe transition duration-300 font-medium border-2 border-tan hover:border-beige"
          >
            Shop Now
          </a>
        </div>

        {/* RIGHT IMAGE - expanded space */}
        <div className="flex-[1.4] relative w-full h-[300px] lg:h-[540px] rounded-3xl overflow-hidden shadow-2xl">
          <img
            src={heroImage}
            alt="Premium Leather Collection"
            className="w-full h-full object-fill"
          />

          {/* Darker overlay for better readability */}
          {/* <div className="absolute inset-0 bg-gradient-to-tr from-charcoal/40 via-darktaupe/40 to-transparent"></div> */}
{/*  */}
          {/* Floating text card - updated to match dark theme */}
          <a
            href={categoryLink}
            className="absolute bottom-6 left-6 bg-offwhite/20 backdrop-blur-md px-6 py-4 rounded-lg shadow-md 
                       hover:bg-offwhite/20 transition duration-300 group border border-beige/20"
          >
            <p className="uppercase text-xs font-semibold tracking-wide text-darktaupe mb-1">
              {loadingCategory ? "Loading..." : "Featured Collection"}
            </p>
            <h2 className="text-2xl font-agatha text-primary leading-snug group-hover:text-darktaupe transition duration-300">
              {categoryName}
            </h2>
          </a>
        </div>
      </div>
      
      {/* Optional: Add a subtle pattern or texture overlay */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-transparent via-charcoal/10 to-darktaupe/20 pointer-events-none"></div>
    </section>
  );
};

export default HeroBanner;